import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "list" ]

  choose(event) {
    const button = event.currentTarget
    const slug = button.dataset.slug
    this.setCookieAndGo(slug)
  }

  autoDetect() {
    if (!navigator.geolocation) return

    navigator.geolocation.getCurrentPosition(
      (position) => this.handlePosition(position),
      () => {},
      { enableHighAccuracy: true, timeout: 10000 }
    )
  }

  handlePosition(position) {
    const districts = this.parseDistricts()
    if (districts.length === 0) return

    const userLat = position.coords.latitude
    const userLon = position.coords.longitude

    let nearest = null
    let minDistance = null

    districts.forEach((district) => {
      const distance = this.haversine(userLat, userLon, district.centerLat, district.centerLon)
      if (minDistance === null || distance < minDistance) {
        minDistance = distance
        nearest = district
      }
    })

    if (nearest) {
      this.setCookieAndGo(nearest.slug)
    }
  }

  parseDistricts() {
    return Array.from(this.listTarget.querySelectorAll("[data-slug]")).map((el) => ({
      slug: el.dataset.slug,
      name: el.dataset.name,
      centerLat: parseFloat(el.dataset.centerLat),
      centerLon: parseFloat(el.dataset.centerLon)
    }))
  }

  setCookieAndGo(slug) {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 1)
    document.cookie = `district=${slug}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`
    window.location.href = `/${slug}`
  }

  haversine(lat1, lon1, lat2, lon2) {
    const R = 6371
    const dLat = this.toRadians(lat2 - lat1)
    const dLon = this.toRadians(lon2 - lon1)
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRadians(lat1)) *
        Math.cos(this.toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return R * c
  }

  toRadians(degrees) {
    return degrees * (Math.PI / 180)
  }
}
